import React from "react";
import { mapReleaseTypeSpeakerToDataTable as mapData } from "./Helper";
import ReusableDndTable from "src/components/table/ReusableDndTable/ReusableDndTable";
import GetReleaseTypeSpeakerColumns from "./ColumnDefinition/ReleaseTypeSpeakerColumn/GetReleaseTypeSpeakerColumns";

const ReleaseTypeSpeakerTable = ({
  data,
  handleOpenPopup,
  handleDelete,
  onDragEnd,
  status,
}) => {
  const columns = GetReleaseTypeSpeakerColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDndTable
      columns={columns}
      data={mapData(data)}
      maxHeight={500}
      onDragEnd={onDragEnd}
    />
  );
};

export default ReleaseTypeSpeakerTable;
